export const GET_STAFF = "GET_STAFF";
export const CREATE_STAFF = "CREATE_STAFF";
export const EDIT_STAFF = "EDIT_STAFF";
export const DELETE_STAFF = "DELETE_STAFF";
export const UPDATE_STAFF_STATUS = "UPDATE_STAFF_STATUS";
